import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

import preferences from "../graph-ql/preferences.graphql";

const useQueryPreferences = (opts?: QueryHookOptions) =>
  useQuery(preferences, opts);

export default useQueryPreferences;
